if (!customElements.get('everest-sticky-cart')) {
  customElements.define('everest-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.label = this.querySelector('[data-sticky-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.variant = this.querySelector('[data-sticky-variant]');
      this.error = this.querySelector('[data-sticky-error]');
      this.spinner = this.querySelector('.ev-sticky-cart__spinner');
      this.onClick = () => this.addToCart();
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.button.addEventListener('click', this.onClick);
      this.root.addEventListener('change', this.schedule);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(this.root, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value', 'style']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.root?.removeEventListener('change', this.schedule);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    get sourceButton() {
      return this.root?.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
    }

    sync() {
      const source = this.sourceButton;
      if (!source || !source.getClientRects().length) {
        this.hidden = true;
        return;
      }
      const busy = source.getAttribute('aria-disabled') === 'true';
      const optionsTarget = this.getOptionsTarget();
      this.button.disabled = !optionsTarget && source.disabled;
      this.button.setAttribute('aria-disabled', String(busy || this.button.disabled));
      this.button.setAttribute('aria-busy', String(source.classList.contains('loading')));
      const popup = source.getAttribute('aria-haspopup');
      if (popup && !optionsTarget) this.button.setAttribute('aria-haspopup', popup);
      else this.button.removeAttribute('aria-haspopup');
      this.spinner.hidden = !source.classList.contains('loading');
      const soldOut = source.querySelector('.sold-out-message:not(.hidden)');
      this.label.textContent = optionsTarget
        ? this.dataset.chooseOptionsLabel
        : (soldOut || source.querySelector('span'))?.textContent.trim() || '';

      const priceRoot = this.root.querySelector(`#price-${this.dataset.sectionId}`);
      const onSale = priceRoot?.querySelector('.price--on-sale');
      const price = priceRoot?.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular span.price-item--regular');
      this.price.textContent = priceRoot && !priceRoot.classList.contains('hidden') ? price?.textContent.trim() || '' : '';
      this.price.hidden = !this.price.textContent;
      const selected = this.root.querySelector('variant-selects [data-selected-variant]');
      let title = '';
      try { title = JSON.parse(selected?.textContent || 'null')?.title || ''; } catch {}
      this.variant.textContent = title === 'Default Title' ? '' : title;
      const errorWrapper = this.root.querySelector('product-form .product-form__error-message-wrapper');
      this.error.textContent = errorWrapper && !errorWrapper.hidden
        ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() || '' : '';
      this.error.hidden = !this.error.textContent;
      this.hidden = source.getBoundingClientRect().bottom >= 0;
    }

    getOptionsTarget() {
      const visible = (element) => element.getClientRects().length > 0
        && getComputedStyle(element).visibility !== 'hidden';
      const controls = 'select, textarea, input:not([type="hidden"]), button, [role="combobox"]';
      const appOptions = Array.from(this.root.querySelectorAll('.bss-po-product-page, .bss-po-option-set'))
        .find((container) => visible(container) && Array.from(container.querySelectorAll(controls)).some(visible));
      if (appOptions) return appOptions;
      const customControl = Array.from(this.root.querySelectorAll(
        'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
      )).find((element) => element.type !== 'hidden' && visible(element));
      if (customControl) return customControl.closest('.shopify-app-block, fieldset, .product-form__input') || customControl;
      const variants = this.root.querySelector('variant-selects');
      if (variants && visible(variants) && Array.from(variants.querySelectorAll(controls)).some(visible)) return variants;
      return null;
    }

    viewOptions(target) {
      const header = document.querySelector('.section-header');
      const headerHeight = header?.getBoundingClientRect().height || 0;
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
      const focusable = 'select:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), button:not([disabled]), [role="combobox"]';
      const control = target.matches(focusable) ? target : Array.from(target.querySelectorAll(focusable))
        .find((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      control?.focus({ preventScroll: true });
      window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    addToCart() {
      const source = this.sourceButton;
      if (!source || source.getAttribute('aria-disabled') === 'true') return;
      const optionsTarget = this.getOptionsTarget();
      if (optionsTarget) {
        this.viewOptions(optionsTarget);
        return;
      }
      if (source.disabled) return;
      source.click();
      this.sync();
    }
  });
}
